export interface SalesOrderProformaSearch {
  includePaid: boolean;
  pay: boolean;
  unpay: boolean;
}
